import { axiosRequest } from '../api';
import { API_PATH } from '../../constants';

export const PendingDeviceService = {
  getPendingDevicesList(params){ return axiosRequest('GET', API_PATH.PENDING_DEVICE.LIST(params)) },
  getPendingDevice(data){ return axiosRequest('POST', API_PATH.PENDING_DEVICE.GET, data) },
  rejectPendingDevice(data){ return axiosRequest('POST', API_PATH.PENDING_DEVICE.REJECT, data) },
  approvePendingDevice(data){ return axiosRequest('POST', API_PATH.PENDING_DEVICE.APPROVE, data) },
}